import currencySymbolMapp from "currency-symbol-map";

export default function currencyFormatFullnumber(value, currency) {
  let result = ''
  let currencySymbol = currencySymbolMapp(currency)

  value = parseFloat(value)

  if (value == 0) {
    result = currencySymbol + ` ${value.toString()}`
  } else {
    result =
      currencySymbol +
      ` ${value
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`
  }

  return result
}
